import moment from 'moment';

export default function() {
  return (date, range = 0, daysOffset = 0) => {
    const startDate = moment(date)
      .add(daysOffset, 'days')
      .subtract(range, 'years');

    return new Date(startDate); // AngularJS template cant parse moment obj properly
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/RangeDate.js